import React, { FC } from 'react'
import { USPList } from '../../helpers/constants'
import styles from './USPSection.module.scss'
import useQA from 'hooks/useQA'

const USPSection: FC = () => {
  const { testId } = useQA()

  return (
    <div className={styles.grid}>
      <div className={styles.uspWrapper}>
        <h3>Why Saatchi Art?</h3>
        <div className={styles.uspContainer} {...testId('usp-container')}>
          {USPList.map((item) => (
            <div key={item.key} className={styles.uspItemBox}>
              <div className={styles.uspItemsIcon}>{item.image}</div>
              <div className={styles.uspTextBox} {...testId('usp-text-box')}>
                <div className={styles.titleBox}>
                  <h6>{item.title}</h6>
                  {item.subTitle !== '' && (
                    <>
                      &nbsp;<h6>{item.subTitle}</h6>
                    </>
                  )}
                </div>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default USPSection
